import React, { useRef, useState } from "react";
import { useLanguageContext } from "../../LanguageProvider";
import SendButton from "../../SendButton";
import AddButton from "./AddButton";
import {
  InputRow,
  SHOW_TEXT_ROW,
  StyledTexContainer,
  TextArea,
} from "../styledTextContainer";
import { translatePlaceholderText } from "./utils";
import { InputPanelProps } from "./InputPanel.types";
import Menu from "../../Menu/Menu";
import { useTextContainerContext } from "../TextContainerProvider";
import { isMobile } from "react-device-detect";
import useAutosizeTextArea from "../../WBBTextContainer/useAutosizeTextArea";
import { useClientSettings } from "../../ClientSettingsProvider/ClientSettingsProvider";

function InputPanel({
  value,
  textNodeRef,
  onChange,
  onKeyDown,
  onToggleMediaPanel,
  onSend,
  isPortal,
  disabled,
}: InputPanelProps) {
  const { lang } = useLanguageContext();
  const placeholder = translatePlaceholderText(lang);
  const timerRef = useRef<null | ReturnType<typeof setTimeout>>(null);
  const { zoomLevel } = useClientSettings();
  const {
    showMediaPanelBtn,
    textAreaRef,
    persistentMenu,
    onClickPersistentMenuItem,
    onAttachFile,
    enableUploadFile,
    msgsContainerRef,
  } = useTextContainerContext();
  const resetAutoSize = useAutosizeTextArea(
    textAreaRef,
    msgsContainerRef,
    value,
    timerRef,
    zoomLevel
  );

  const [focused, setFocused] = useState(false);

  const onFocus = () => setFocused(true);
  const onBlur = () => setFocused(false);

  const handleSend = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (value.trim() !== "") {
      onSend(event);
    }
    resetAutoSize();
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
    if (!enableUploadFile) {
      return;
    }
    const { items } = e.clipboardData;
    let isFile = false;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.kind === "file") {
        const file = item.getAsFile();
        onAttachFile(file!, null);
        isFile = true;
      }
    }
    if (isFile) {
      e.preventDefault();
    }
    return;
  };

  return (
    <InputRow ref={textNodeRef} className={SHOW_TEXT_ROW}>
      {showMediaPanelBtn && (
        <AddButton onClick={onToggleMediaPanel} disabled={disabled} />
      )}
      <StyledTexContainer focused={focused} zoomLevel={zoomLevel}>
        <TextArea
          mobile={isMobile}
          disabled={disabled}
          ref={textAreaRef}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          onFocus={onFocus}
          onBlur={onBlur}
          onPaste={handlePaste}
        />
        <SendButton
          onClick={handleSend}
          isPortal={isPortal}
          disabled={disabled}
        />
      </StyledTexContainer>
      {persistentMenu?.length && (
        <Menu
          parentElement={textNodeRef.current}
          elements={persistentMenu}
          onClickItem={onClickPersistentMenuItem}
        />
      )}
    </InputRow>
  );
}

export default InputPanel;
